<template>
  <p class="db-rate">
    <span class="db-rate-main">
      <span
        v-if="$slots.prefix"
        class="db-uppercase db-rate-prefix"
      >
        <slot name="prefix" />
      </span>
      <span class="db-rate-value">
        <slot name="rate" />
      </span>
      <span
        v-if="$slots.suffix"
        class="db-rate-suffix"
      >
        <slot name="suffix" />
      </span>
    </span>
    <span
      v-if="$slots.rateold"
      class="db-rate-old db-line-through"
    >
      <slot name="rateold" />
    </span>
    <span
      v-if="$slots.details"
      class="db-rate-line"
    >
      <slot name="details" />
    </span>
    <span
      v-if="$slots.footernote"
      class="db-rate-footernote"
    >
      <slot name="footernote" />
    </span>
  </p>
</template>
<style>
.db-app {
  --db-font-size-rate-prefix: var(--db_small_body_text_font_size);
  --db-font-size-rate: var(--db_rates_font_size);
  --db-font-size-rate-suffix: var(--db_body_text_font_size);
}
</style>
<style scoped>
/* Rate wrapper */
.db-app .db-rate {
  display: grid;
  gap: var(--db-spacer-2);
}

/* Rate prefix (usually "From") */
.db-app .db-rate-prefix {
  font-size: var(--db-font-size-rate-prefix);
  color: var(--db_secondary_body_text_color);
}

/* Rate suffix (usually "Per person/day") */
.db-app .db-rate-suffix {
  font-size: var(--db-font-size-rate-suffix);
}

.db-app .db-text-right .db-rate-main {
  justify-content: end;
}

.db-app .db-rate-main {
  display: grid;
  gap: var(--db-spacer-6);
  grid-auto-flow: column;
  grid-auto-columns: minmax(min-content, max-content);
  align-items: center;
  line-height: 1;
}

/* Actual rate */
.db-app .db-rate-value {
  font-family: var(--db_rates_font_family);
  color: var(--db_rate_color);
  font-weight: var(--db_rates_font_weight);
  font-size: var(--db-font-size-rate);
}

/* Old rate (strikethrough rate) */
.db-app .db-rate-old {
  order: -1;
  font-size: var(--db_strikethrough_pricing_font_size);
  color: var(--db_strikethrough_pricing_color);
}

/* Rate footer note */
.db-app .db-rate-footernote {
  font-size: 12px;
  color: var(--db_secondary_body_text_color);
}

@media screen and (min-width: 567px) {
  /* Rate footer note */
  .db-app .db-rate-footernote {
    font-size: var(--db_small_body_text_font_size);
  }
}
</style>
